import { ChangeDetectionStrategy, Component, ElementRef, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { WindowRef } from '@spartacus/core';
import { HamburgerMenuService, NavigationNode, NavigationUIComponent } from '@spartacus/storefront';
import { MenuMobileService } from '../header/menu-mobile.service';
import { DEVICE_SIZE } from '../../../../../core/models/others.model';

@Component({
  selector: 'custom-cx-navigation-ui',
  templateUrl: './navigation-ui.component.html',
  styleUrl: './navigation-ui.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomNavigationUIComponent extends NavigationUIComponent implements OnChanges {
  placeholderImage = '../../../../../../../assets/medias/images/banners/home-banner-1-wide.png';
  selectedIndex: number | null = null;
  DEVICE_SIZE = DEVICE_SIZE;

  constructor(
    private _router: Router,
    private _renderer: Renderer2,
    private _elemRef: ElementRef,
    private _hamburgerMenuService: HamburgerMenuService,
    private _winRef: WindowRef,
    private serviceMenu: MenuMobileService,
  ) {
    super(_router, _renderer, _elemRef, _hamburgerMenuService, _winRef);
  }
  toggleIndex(index: number) {
    if (this.selectedIndex === index) {
      this.selectedIndex = null;
    } else {
      this.selectedIndex = index;
    }
  }

  toggleIndexonKeydown(event: KeyboardEvent, index: number) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.toggleIndex(index);
      event.preventDefault();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.countNodeLevels(this.node?.children);
    }
  }

  closeMainMenu() {
    this.serviceMenu.close();
  }

  open(ev: any) {
    const $btn = ev.currentTarget as HTMLElement;
    const $li = $btn.closest('li')?.querySelector('.js-level');

    $li && $li.classList.add('active');
  }

  toggleExpand(ev: any): void {
    const $btn = ev.currentTarget as HTMLElement;
    const $li = $btn.closest('li')?.querySelector('.js-level');

    $btn && $btn.classList.toggle('active');
    $li && $li.classList.toggle('active');
  }

  customBack(ev: any) {
    if (this.selectedIndex !== null) {
      this.selectedIndex === null;
      return;
    }
    const $level = (ev.currentTarget as HTMLElement).closest('.js-level');

    if ($level) {
      $level.classList.toggle('active');

      if (!$level.classList.contains('active')) {
        $level.querySelectorAll('.active').forEach($level => {
          $level.classList.remove('active');
        });
      }
    }
  }

  isCurrentUrl(node: NavigationNode) {
    const url: string = Array.isArray(node.url) ? node.url.join(', ') : node.url || '';
    return this.winRef.isBrowser() && this.winRef.location.pathname?.includes(url);
  }

  countNodeLevels(nodes: any[] | undefined): number {
    if (!nodes) return 0;

    nodes.forEach(node => {
      node.levels = this.calculateLevels(node);
    });

    return nodes.length;
  }

  calculateLevels(node: any): number {
    if (!node.children || node.children.length === 0) {
      return 1;
    }
    const childLevels = node.children.map((child: any) => this.calculateLevels(child));

    return 1 + Math.max(...childLevels);
  }
}
